webpackJsonp([229246663810028],{

/***/ 454:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Razy Technologies"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/leveraging-cloud-services-results-in-seamless-distribution-of-lubricant-oil-in-mena/"},"frontmatter":{"title":"Leveraging Cloud Services Results in Seamless Distribution of Lubricant Oil in MENA"}}}]}},"pathContext":{"tag":"campaigns"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-campaigns-d6aa4eedace62120751b.js